export class PolicyDashboardMdl
{
  public ProductCode: string;
  public TotalPolicies: number;
  public ActivePolicies: number;
  public PendingProposals: number;
  public ExpiredPolicies: number;
  public CancelledPolicies: number;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/PolicyDashboardMdl.ts